import InternalFilter from './Filter';
import FilterButton from './FilterButton';
import FilterDateRange from './FilterDateRange';
import FilterDropdown from './FilterDropdown';
import FilterItem from './FilterItem';
import FilterRadioGroup from './FilterRadioGroup';
import FilterRange from './FilterRange';
import FilterSalaryRange from './FilterSalaryRange';
import FilterSection from './FilterSection';
import FilterSelection from './FilterSelection';
import FilterTag from './FilterTag';

type InternalFilterType = typeof InternalFilter;

interface FilterInterface extends InternalFilterType {
  Button: typeof FilterButton;
  Dropdown: typeof FilterDropdown;
  Item: typeof FilterItem;
  RadioGroup: typeof FilterRadioGroup;
  Range: typeof FilterRange;
  Selection: typeof FilterSelection;
  Tag: typeof FilterTag;
  DateRange: typeof FilterDateRange;
  SalaryRange: typeof FilterSalaryRange;
  Section: typeof FilterSection;
}

const Filter = InternalFilter as FilterInterface;

Filter.Button = FilterButton;
Filter.Dropdown = FilterDropdown;
Filter.Item = FilterItem;
Filter.RadioGroup = FilterRadioGroup;
Filter.Range = FilterRange;
Filter.Selection = FilterSelection;
Filter.Tag = FilterTag;
Filter.DateRange = FilterDateRange;
Filter.SalaryRange = FilterSalaryRange;
Filter.Section = FilterSection;

export default Filter;
